import { RECONCILIATION as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    align: 'center',
    menu: false,
    border: true,
    refreshBtn: false,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      { label: LABELS.statementNumber, prop: 'reconNumber', search: true },
      { label: LABELS.reconciliationQuantity, prop: 'confirmQuantity' },
      { label: LABELS.numberOfInvoicesIssued, prop: 'invoiceQuantity' },
      { label: LABELS.numberOfInvoicesAvailable, prop: 'noInvoiceQuantity' },
      { label: LABELS.priceIncludeTax, prop: 'priceIncludingTax' },
      { label: LABELS.taxCode, prop: 'taxCode' },
      { label: LABELS.orderNumber, prop: 'orderNumber', search: true },
      { label: LABELS.orderQuantity, prop: 'quantity' },
      { label: LABELS.materialNumber, prop: 'materialNumber' },
      { label: LABELS.materialName, prop: 'materialName' }
    ]
  }
};
